import Popup from 'reactjs-popup';
import Proptypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import DeleteTeamModal from './DeleteTeamModal';
import RenameTeamModal from './RenameTeamModal';
import { UsersSelectors } from '../../../Redux/modules/users/selectors';
import { UsersActions } from '../../../Redux/modules/users/actions';

const Modals = (props) => {
  const { selectedTeam, actions, close, teams } = props;
  const onModalOpen = (actionItem) => {
    if (actionItem.name === 'DELETE_TEAM') {
      return props.deleteTeamModalOpen;
    }
    if (actionItem.name === 'RENAME_TEAM') {
      return props.renameTeamModalOpen;
    }
    return false;
  };
  const getModal = (item, userData) => {
    let modal;

    switch (item.name) {
      case 'DELETE_TEAM':
        modal = <DeleteTeamModal userData={userData} title={item.title} />;
        break;
      case 'RENAME_TEAM':
        modal = <RenameTeamModal userData={userData} title={item.title} teams={teams} />;
        break;

      default:
        modal = <RenameTeamModal userData={userData} title={item.title} />;
    }

    return modal;
  };

  const getModalStyle = () => {
    return {
      width: '528px',
      boxShadow: 'rgba(101, 101, 101, 0.28) 0px 4px 12px 0px',
      border: 'none',
      borderRadius: '8px',
      padding: '40px 80px',
      backgroundColor: '#ffffff',
    };
  };
  return (
    <>
      {actions.map((item) => (
        <Popup
          key={item.name}
          contentStyle={getModalStyle(item)}
          modal
          open={onModalOpen(item, props)}
          onClose={close}
          closeOnDocumentClick={false}
        >
          {getModal(item, selectedTeam)}
        </Popup>
      ))}
    </>
  );
};

Modals.propTypes = {
  close: Proptypes.func,
  selectedTeam: Proptypes.object,
  teams: Proptypes.array,
  actions: Proptypes.array,
  deleteTeamModalOpen: Proptypes.bool,
  renameTeamModalOpen: Proptypes.bool,
};

const mapStateToProps = (state) => {
  return {
    renameTeamModalOpen: UsersSelectors.renameTeamModalSelector(state),
    deleteTeamModalOpen: UsersSelectors.deleteTeamModalSelector(state),
    selectedTeam: UsersSelectors.currentClickedUserSelector(state),
    teams: UsersSelectors.teamsSelector(state),
  };
};

const mapDispatchToProps = {
  close: UsersActions.clickedCloseModalButton,
};

export default connect(mapStateToProps, mapDispatchToProps)(Modals);
